import React from 'react'
import styled from 'styled-components'
import { Field } from 'react-final-form'
import StyledRadioField from 'components/StyledRadioField'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormHelperText from '@material-ui/core/FormHelperText'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'

const RadioGroupField = ({
  id,
  type,
  name,
  helperText,
  variant,
  validate,
  InputProps,
  options,
  ...props
}) => {
  return (
    <Field
      name={name}
      type={type}
      validate={validate}
    >
      {({ input, meta }) => {
        return (
          <FormControl component="fieldset">
            <RadioGroup
              aria-label={name}
              name={name}
              error={meta.error && meta.touched}
              helperText={meta.error && meta.touched ? meta.error : helperText}
              {...input}
            >
              {options && options.map((o, i) => (
                <FormControlLabel
                  key={o.value}
                  value={o.value}
                  label={o.label}
                  labelPlacement="end"
                  {...props}
                  control={
                    <StyledRadioField
                      radioColor={o.color || "primary"}
                      variant={variant}
                    />
                  }
                />
              ))}
            </RadioGroup>
          </FormControl>
        )
      }}
    </Field>
  )
}

export default RadioGroupField